module.exports = __webpack_public_path__ + "img/zoetrope5.7bbee275.gif";